if ($('form').length) {
    require([
        '@spinnwerk/form-helper/prevent-mobile-zoom',
        '@spinnwerk/form-helper/loading-indicator',
        '@spinnwerk/form-helper/select-all',
        '@spinnwerk/form-helper/file-input',
        '@spinnwerk/form-helper/label-floating',
        './multiupload',
        './validation',
        './conditionals',
    ], (preventMobileZoom, loadingIndicator, selectAll, fileInput, floatingLabel) => {
        // prevent mobile zoom in
        preventMobileZoom.default();

        // automatically attach an loading indicator to submit buttons on form submit
        loadingIndicator.default();

        // enable an (de)select all radiobutton and checkboxes possibility
        selectAll.default();

        // style advanced file inputs
        fileInput.default({
            multibleFilesLabel: ':anz Dateien ausgewählt',
        });

        // automatically attach an loading indicator to submit buttons on form submit
        floatingLabel.default();

        // remove file on icon click and trigger change event
        $('.input--file__input__icon').on('click', function () {
            $(this).closest('.input--file')
                .find('input[type="file"]').val('')
                .trigger('change');
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/form.js